import type { Route } from '@dpdgroupuk/fmx-ui/types';

export const getDriverId = (route: Route): string =>
  `${route.depotCode}*${route.driverCode}`;

export const isElectric = (vehicleTypeCode: string): boolean =>
  ['ENV', 'ECA', 'EAV', 'PAX', 'RED', 'PAR'].includes(vehicleTypeCode);
